import { useState, useEffect } from 'react';
import useLanguage from '@/hooks/useLanguage';
import replaceText from '@/helpers/replaceText';
import { IHookReplaceText } from '@/helpers/interface';

const DEFAULT_LANGUAGE = 'en_us';
let currentLanguage = DEFAULT_LANGUAGE;

export default (customLang?: { [key: string]: string }) => {
  const lang = JSON.parse(useLanguage()?.appConfig?.message);
  const [language, setLanguage] = useState(currentLanguage);
  const languages = [DEFAULT_LANGUAGE];
  useEffect(() => {
    currentLanguage = language || DEFAULT_LANGUAGE;
  }, [language]);
  const translate = (key: string, replaceMap?: IHookReplaceText) => {
    const str = customLang?.[key] || lang?.[key] || key;
    if (replaceMap) {
      return replaceText(str, replaceMap);
    } else {
      return str;
    }
  };
  return { t: translate, translate, setLanguage, language, languages };
};
